import React, { useState } from 'react';
import { Radio, Row, Col } from 'antd';
import { CardContainer, StyledCards } from './styles';
import { WebsiteImage } from 'components/TitleDescription';
import Text from 'components/Core/Text';
import getBreakpointView from 'utils/getBreakpointView';
import Slider from 'react-slick';
import { getCtaLink, getCtaLabel, getTitle, getImageSrc } from 'components/Page/Toolbox/utils';
import useDefaultCoverPhoto from 'hooks/useDefaultCoverPhoto';

const ResourceSwitch = props => {
  const { data, radio } = props || {};
  const [contentType, setContentType] = useState('Webinars');
  const [nav, setNav] = useState(null);
  const isMobile = getBreakpointView(['xs', 'sm']);
  const defaultCardCover = useDefaultCoverPhoto();
  const handleSizeChange = e => {
    setContentType(e.target.value);
  };
  const contentData = {
    Webinars: data.allContentfulWebinar,
    Guides: data.allContentfulGatedContentPage,
    Podcasts: data.allContentfulPodcast,
    Articles: data.allArticle,
    Tools: data.allTools,
    'Growth Series': data.allGrowthSeries,
  };

  const sliderProps = {
    asNavFor: nav,
    ref: slider => setNav(slider),
    infinite: true,
    slidesToShow: 1,
    swipeToSlide: true,
    centerMode: true,
    focusOnSelect: true,
    arrows: false,
    variableWidth: true,
    style: { marginBottom: '30px' },
  };

  return (
    radio && (
      <CardContainer background="#333333">
        <Radio.Group
          style={{ width: '100%', marginBottom: '30px' }}
          value={contentType}
          onChange={handleSizeChange}
        >
          {!isMobile ? (
            <Row justify="start" gutter={[45, 30]}>
              {radio.map((r, index) => (
                <Col key={index}>
                  <RadioButton r={r} index={index} fontSize="20px" />
                </Col>
              ))}
            </Row>
          ) : (
            <Slider {...sliderProps}>
              {radio.map((r, index) => (
                <RadioButton r={r} key={index} fontSize="18px" />
              ))}
            </Slider>
          )}
        </Radio.Group>
        <Row gutter={[43, 0]}>
          {contentData[contentType]?.nodes?.slice(0, isMobile ? 1 : 3)?.map((card, index) => (
            <Col key={index} xs={24} sm={24} md={8} lg={8}>
              <StyledCards
                backgroundColor={card.toolboxCardColor}
                type={'Image'}
                bodyType={'simple'}
                coverImage={getImageSrc(card) || defaultCardCover.image}
                title={getTitle(card)}
                ctaTitle={getCtaLabel(card)}
                ctaLink={getCtaLink(card)}
              />
            </Col>
          ))}
        </Row>
      </CardContainer>
    )
  );
};

const RadioButton = ({ r, fontSize }) => (
  <Radio.Button value={r.title}>
    <div className="resource-switch--icon-container">
      <WebsiteImage src={r.icon?.src} alt={r.icon?.alt} />
    </div>
    <Text color="white" size={fontSize} type="p">
      {r.title}
    </Text>
  </Radio.Button>
);
export default ResourceSwitch;
